import { LocalStorageKey, getLocalStorage } from "@util/storage";
import { initialState, update } from "./reducers/user";
import { dispatch } from ".";
import { api } from "@util/api";

export const preloadedState = () => {
  const user = getLocalStorage(LocalStorageKey.User, true) || initialState;
  const token = getLocalStorage(LocalStorageKey.Token, true);
  dispatch(update(user));
  if (!token?.accessToken) {
    return;
  }
  if (!user.id || !user.profile) {
    api
      .get("/api/v1/auth/me")
      .then((res) => res.data)
      .then((res) => {
        if (res.data.id) {
          dispatch(update(res.data));
        }
      });
  }
};
